/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { CreateCompanyResponse, ISearchClient } from '../../../../api-service/clients/auto-generated-clients';
import { Button } from '../../../../components/button/button';
import { moduleClientFactory } from '../../../../api-service/module-client-factory';
import { useRowActions } from '../../../search/contextProviders/row-action-provider';
import { useNotifier } from '../../../../components/notifier/notifier-context';
import { deconstructError, isAuthError } from '../../../../utilities/error-helper';
import { useApi } from '../../../../hooks';

export interface CreateCompanyButtonProps {
  productionUnitIdentifier: string | undefined;
}
const useStyles = makeStyles()((theme: Theme) =>
  ({
    createCompanyButton: {
      width: 'fit-content',
      marginTop: theme.spacing(2),
    },
    createCompanyIcon: {
      marginRight: theme.spacing(1),
    },
  })
);

export function CreateCompanyButton(props: CreateCompanyButtonProps): JSX.Element {
  const { productionUnitIdentifier } = props;
  const { classes } = useStyles();
  const rowActions = useRowActions();
  const { dispatch } = useNotifier();
  const [submitting, setSubmitting] = useState<boolean>(false);

  const searchClient: ISearchClient = moduleClientFactory.createSearchClient(true);
  const createCompanyApi = useApi(cancelToken => searchClient.createCompany({ productionUnitIdentifier }, cancelToken), {} as CreateCompanyResponse);

  function handleCreateCompany() {
    setSubmitting(true);

    createCompanyApi.invoke();
  }

  useEffect(() => {
    if (!createCompanyApi?.result?.companyId) {
      return;
    }

    setSubmitting(false);

    const rowAction = rowActions?.find(x => x.resultType.toLowerCase() === 'company');
    const res = createCompanyApi.result;
    if (res.companyId && rowAction && rowAction.url) {
      const url = rowAction.url.replace('{record.guid}', res.companyId);
      window.open(url, rowAction.resultType + res.companyId);
    }
  }, [createCompanyApi.isReady]);

  useEffect(() => {
    if (!createCompanyApi.error) {
      return;
    }

    setSubmitting(false);

    const err = createCompanyApi.error;

    if (isAuthError(err)) {
      dispatch({ type: 'notify', payload: deconstructError(err) });
    }
  }, [createCompanyApi.isError]);

  return (
    <Button loading={submitting} onClick={handleCreateCompany} color="primary" variant="outlined" className={classes.createCompanyButton}>
      <FontAwesomeIcon className={classes.createCompanyIcon} icon={faPlus} />
      Opret
    </Button>
  );
}
